import React from "react";
import { Input } from "antd";
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
 import {Actions} from '../../../Action/index';
import { getBriefPlanning,saveBriefs } from '../../../API/api';
import { toast } from "react-toastify";

export default function NewSearchBar() {
  const briefState = useSelector((state) => state.brief);
  const userState = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const {briefQueryChange,briefFromSeaerchChange,briefisInputShowChange,briefIsLoadingChange,briefAgenticIdChange,briefPanningBreakdownChange,newBriefChange,usedBriefCountChanged} = bindActionCreators(Actions, dispatch);
  const getAccess = ()=>{
    let accessToken = JSON.parse(localStorage.getItem("accessToken")).value;
    return accessToken;
  }
  const onClickSubmit =()=>{
      if(briefState.externalSources.includes('targeturl') && briefState.links.length===0){
        toast.error(successfulHelpful("Urls are required."), {
        position: toast.POSITION.TOP_RIGHT,
      });
        return;
      }
          briefFromSeaerchChange(false);
      briefIsLoadingChange(true);
      briefisInputShowChange(1);
      let obj={
        userQuery:briefState.query,
        language:briefState.lang,
        sources:briefState.externalSources.concat(briefState.internalSources).toString(),
        briefFormat:briefState.briefType,
        suggestions:briefState.suggestions,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        accessToken:localStorage.getItem("accessToken")? getAccess() : "",
        urls:briefState.externalSources.includes('targeturl')?briefState.links.split(','):undefined
      }
      let formData=new FormData();
      formData.append("metadata", JSON.stringify(obj));
      briefState.files.forEach((file, index) => {
      formData.append(`files`, file); // Appending actual file object as binary
      });
      getBriefPlanning(formData).then(res=>{
        if(res===undefined){
          return;
        }
        briefIsLoadingChange(false)
        briefPanningBreakdownChange(res.data.data.suggestedChanges);
        briefAgenticIdChange(res.data.data.agenticId);
        // briefRespChange(res.data.data.suggestedChanges);
      })
    }
  
    const onClickAction =()=>{

      if(briefState.externalSources.includes('targeturl') && briefState.links.length===0){
        toast.error(successfulHelpful("Urls are required."), {
        position: toast.POSITION.TOP_RIGHT,
      });
        return;
      }
          briefFromSeaerchChange(false);

      usedBriefCountChanged(userState.usedBriefCount + 1);
      briefIsLoadingChange(true);
      briefisInputShowChange(3);
      let obj={
        userQuery:briefState.query,
        language:briefState.lang,
        sources:briefState.externalSources.concat(briefState.internalSources).toString(),
        briefFormat:briefState.briefType,
        suggestions:false,
        planningBreakdown:briefState.planningBreakdown,
        agenticId:briefState.id,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        accessToken:localStorage.getItem("accessToken")?  getAccess() : "",
        urls:briefState.externalSources.includes('targeturl')?briefState.links.split(','):undefined
      }
      let formData=new FormData();
      formData.append("metadata", JSON.stringify(obj));
      briefState.files.forEach((file, index) => {
      formData.append(`files`, file); // Appending actual file object as binary
      });
      getBriefPlanning(formData).then(res=>{
        if(res===undefined){
          return;
        }
        briefIsLoadingChange(false)
        // briefRespChange(res.data.data.suggestedChanges);
      })
    }
    const onClickNewBrief=()=>{
          briefFromSeaerchChange(false);

      newBriefChange();
    }
    const successfulHelpful = (message) => {
      return (
        <>
          <span style={{ fontSize: "12px" }}>{message}</span>
        </>
      );
    };
  
    // const onClickCopy=()=>{
    //   console.log(copyToClipboard.current)
    // }
    const onClickSave=()=>{
          briefFromSeaerchChange(false);

      // setHide(true);
      saveBriefs(briefState.id);
      toast.success(successfulHelpful("Agentic flow has been updated successfully."), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
    const onClickEditAction=()=>{
      // console.log(briefState);
          briefFromSeaerchChange(false);

      briefisInputShowChange(2);
    }
  return (
    <>
      <div style={{ marginTop: "3vh" }}>
        <div style={containerStyles}>
          {/* <span> */}
            <Input.TextArea
              size={"large"}
              autoComplete="off"
              id="inputID"
              disabled={briefState.phase===0?false:true}
              width={'100%'}
              rows={2}
              placeholder="Enter your brief request here."
              style={{
                border: "none",
                color: "#5C667B",
                fontSize: "18px",
                fontWeight: "400",
                borderRadius:'20px',
                // padding:"0px",
                // paddingLeft:'10px',
                // marginBottom:'10px'
              }}
              
              
              onChange={(e)=>briefQueryChange(e.target.value)} value={briefState.query}
            />
          {/* </span> */}
          {briefState.phase ===1 &&
            <div className="mt-2" style={{ display: "flex", justifyContent: "space-between" }}>
            {!briefState.isLoading && briefState.phase ===1 && <><div style={{display:'flex',alignItems:'center',color:'#5c667b'}}><button style={buttonCancelStyles} onClick={()=>onClickNewBrief()}>Cancel</button>&nbsp;<button style={buttonStyles}  onClick={()=>onClickEditAction()}>Edit Plan</button></div><div><button style={buttonStyles} onClick={()=>onClickAction()}>Perform Action</button></div></>}
          </div>
          }
          {briefState.phase !==1 && <div className="mt-2" style={{ display: "flex", justifyContent: "end" }}>
            {!briefState.isLoading &&briefState.phase===3 && <div className="mt-2"><button style={buttonStyles}  onClick={()=>onClickNewBrief()}>New Brief</button></div>}
            {briefState.phase===2 && <div className="mt-2"><button style={buttonStyles} onClick={()=>onClickAction()}>Perform Action</button></div>}
          {userState.usedBriefCount !==userState.briefThreshold && briefState.phase===0 && briefState.query.length > 0 && <div className="mt-2"><button style={buttonStyles}  onClick={()=>onClickSubmit()}>Submit</button></div>}
          {userState.usedBriefCount ===userState.briefThreshold && briefState.phase===0 && briefState.query.length > 0 && <div className="mt-2"><button style={buttonDisabledStyles} disabled onClick={()=>onClickSubmit()}>Submit</button></div>}
          {briefState.phase===0 && briefState.query.length===0 && <div className="mt-2"><button style={buttonDisabledStyles}  disabled >Submit</button></div>}
          </div>}
        </div>
      </div>
    </>
  );
}

const containerStyles = {
    // border: "1px solid #EAECF0",
    boxShadow: "0px 0px 20px 2px #00000040",
    borderRadius: "30px",
    background: "#ffffff",
    padding: "16px",
    width: "100%",
    // display: "flex",
    // justifyContent: "space-between",
    // alignItems: "center",
  };
  const buttonStyles = {
    border: "none",
    paddingBlock: "10px",
    paddingInline: "25px",
    borderRadius: "30px",
    fontSize: "16px",
    background: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    color: "#ffffff",
    width:'max-content',
    cursor:'pointer'
  };

  const buttonCancelStyles = {
    border: "1px solid #acb6c6",
    paddingBlock: "10px",
    paddingInline: "25px",
    borderRadius: "30px",
    fontSize: "16px",
    background: "#fff",
    color: "black",
    width:'max-content'
  };

  const buttonDisabledStyles = {
    border: "none",
    paddingBlock: "10px",
    paddingInline: "25px",
    borderRadius: "30px",
    fontSize: "16px",
    background: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
    color: "#ffffff",
    width:'max-content',
    cursor:'not-allowed',
    opacity:0.5
  };
